/* lua.js generated code 0.3.0 */
 // 静态工具类
UIUtils = xClass("UIUtils")
unicode_split_reg = /(?=(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]))/
UIUtils.fixTextWidth = function (textField, str, width, tail) {
    tail = tail || "..."
    // 这里 textField setString 之后 ignoreContentAdaptWithSize 无变化，所以这么处理
    textField.ignoreContentAdaptWithSize && textField.ignoreContentAdaptWithSize(true)
    textField.setString(str)
    var fakeTxt = ccui.Text.create()
    fakeTxt.ignoreContentAdaptWithSize(true)
    fakeTxt.setFontSize(textField.getFontSize())
    fakeTxt.setFontName(textField.getFontName())
    fakeTxt.setString(str)
    let textWidth = fakeTxt.getVirtualRendererSize().width;
    if (textWidth > width) {
        var midStr = ""
        let arr = str.split(unicode_split_reg)
        for(let index in arr){
            let xchar = arr[index]
            if (xchar == null) break
            midStr = midStr + xchar
            fakeTxt.setString(midStr + tail)
            const temp = fakeTxt.getVirtualRendererSize().width;
            if (temp > width) {
                return textWidth;
            } else {
                textWidth = temp;
                textField.setString(midStr + tail)
            }
        }
    }else {
        return textWidth
    }
}
UIUtils.fixTextWidthWithLabel = function (label, str, width) {
    label.setString(str)
    if (label.getContentSize().width > width) {
        let midStr = ""
        let arr = str.split(unicode_split_reg)        
        for(let index in arr){
            let xchar = arr[index]
            label.setString(midStr + xchar + "...")
            if (label.getContentSize().width > width) {
                label.setString(midStr + "...")
                return
            }else{
                midStr = midStr + xchar
            }
        }
        // var midStr = ""
        // var $st8 = string.gfind(tostring(str), "[%z\\1-\\127\\194-\\244][\\128-\\191]*")
        // while(1) {
        //     var t = $st8[0]($st8[1], $st8[2])
        //     var xchar = t[0]
        //     if (xchar == null) break
        //     $st8[2] = xchar
        //     label.setString(midStr + xchar + "...")
        //     if (label.getContentSize().width > width) {
        //         label.setString(midStr + "...")
        //         return 
        //     } else {
        //         midStr = midStr + xchar
        //     }
        // }
    }
}
UIUtils.limitNameLength = function (str, length) {
    var retStr = ""
    var curLength = 0
    let arr = str.split(unicode_split_reg)    
    for(let index in arr){
        let xchar = arr[index]
        curLength = curLength + 1
        if (curLength > length) {
            return retStr + "..."
        }
        retStr = retStr + xchar
    }
    return retStr
    // var $st13 = string.gfind(tostring(str), "[%z\\1-\\127\   \194-\\244][\\128-\\191]*")
    // while(1) {
    //     var t = $st13[0]($st13[1], $st13[2])
    //     var xchar = t[0]
    //     if (xchar == null) break
    //     $st13[2] = xchar
    //     if (xchar.len() > 1) {
    //         curLength = curLength + 2
    //     } else {
    //         curLength = curLength + 1
    //     }
    //     if (curLength > length) {
    //         return retStr + "..."
    //     }
    //     retStr = retStr + xchar
    // }
    // return retStr
}
UIUtils.loadedEffectRes = {}
UIUtils.preStrOfFontNameSizeWidth = {} //指定字体字号宽度
//nameEffectId 91111
UIUtils.createNameWithUserShow = function (NameTextNode, string, width, userShow, extra = {}) {
    const fontConfig = { //描边色 资源 
        91003 : ["#4473D1" ,["font/FZY3KLite.ttf","font/nameeffect_whitesnow.png"]], //蓝点 
        91004 : ["#E46C1F" ,["font/FZY3KLite.ttf","font/nameeffect_light.png"]], //金扫光
        91005 : ["#7c00b6" ,["font/FZY3KLite.ttf","font/nameeffect.plist", "font/nameeffect_light.png"]],//紫扫光
        91006 : ["#7c00b6" ,["font/FZY3KLite.ttf","font/nameeffect.plist"]],//彩虹
        91007 : ["#CC341D" ,["font/FZY3KLite.ttf","font/nameeffect_fire.plist"]],//火焰
    }

    let nameLabelId = UIUtils.getIdFromUsershow(userShow, "label") || extra.label
    let nameEffectId = UIUtils.getIdFromUsershow(userShow, "nameEffect") || extra.nameEffect

    // function randomString(length) {
    //     const chars = 'ABCDEFGHIJKLMNOP海滨消消乐QRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    //     let result = '';
    //     for (let i = 0; i < length; i++) {
    //     result += chars.charAt(Math.floor(Math.random() * chars.length));
    //     }
    //     return result;
    // }
    // string = randomString(16)

    // const options = [0, 91002, 91003, 91004, 91005, 91006, 91007];
    // nameEffectId =  options[Math.floor(Math.random() * options.length)]
    // nameLabelId =  Math.random() < 0.5 ? 0 : 91001
    // nameLabelId = 91001
    // NameTextNode.setScale(3)
    // nameEffectId = 91003
    // if (!NameTextNode instanceof ccui.Text){ //统一成ccui.Text
    //     Toast.make("ERROR 字体类型错误")
    //     console.error("createNameWithUserShow", NameTextNode, NameTextNode instanceof ccui.Text, NameTextNode instanceof cc.LabelTTF,NameTextNode instanceof cc.Label, string, width, nameLabelId, nameEffectId, userShow)
    //     return
    // }
    console.log("createNameWithUserShow", string, width, nameLabelId, nameEffectId, userShow, extra)



    function setFontColor(node, color){
        node.setCascadeColorEnabled(false)
        node.setColor && node.setColor(cc.color(255, 255,  255, 255))
        node.setTextColor && node.setTextColor(cc.color(255, 255,  255, 255))
        if ( node.setTextColor){
            // console.log("createNameWithUserShow setTextColor",  string, NameTextNode.__instanceId, color)
            
            node.setTextColor(color)
        }else if (node.setColor){
            // console.log("createNameWithUserShow setColor",  string, NameTextNode.__instanceId, color)
            
            node.setColor(color)
        }

    }

    function getFontColor(node){
        let color1 = cc.color(255, 255,  255, 255)
        let color2 = cc.color(255, 255,  255, 255)
        if ( node.getColor){
            // console.log("createNameWithUserShow getColor",  node.getColor())
            color1 = node.getColor()
        }
        if (node.getTextColor){
            // console.log("createNameWithUserShow getTextColor",  node.getTextColor())
            color2 = node.getTextColor()
        }
        if (color1._val != cc.color(255, 255, 255, 255)._val){
            return color1
        }
        if (color2._val != cc.color(255, 255, 255, 255)._val){
            return color2
        }
        return cc.color(255, 255, 255, 255)
    }

    function changeToOriginalStyle(originalStyle){
        setFontColor(NameTextNode, originalStyle.originFontColor)
        NameTextNode.setFontName(originalStyle.fontName)
        if (NameTextNode.nameLabel){ //目前只有通行证
            NameTextNode.nameLabel.removeFromParent()
            NameTextNode.nameLabel = null
        }
        
        if (NameTextNode.shineNode){
            NameTextNode.shineNode.x = 0
            NameTextNode.shineNode.setVisible(false)
            NameTextNode.shineNode.removeAllChildren()
        }
        
        NameTextNode.enableOutline(originalStyle.originFontColor, 0.01);
        // maskTextNode
        NameTextNode.getVirtualRenderer().setShaderProgram(cc.shaderCache.programForKey(cc.SHADER_SPRITE_POSITION_TEXTURECOLORALPHATEST));
        
    }

    //重置为初始状态
    if (!NameTextNode.originalStyle){
        NameTextNode.originalStyle ={ 
            originFontColor : clone(getFontColor(NameTextNode)),
            fontName : NameTextNode.getFontName()
        } 
    }
    changeToOriginalStyle(NameTextNode.originalStyle)
    

    function getPreStr(fontName, size, offsetX){
        let key = fontName + size + offsetX.toFixed(1).replace(".", "")
        if (UIUtils.preStrOfFontNameSizeWidth[key]) {
            return UIUtils.preStrOfFontNameSizeWidth[key]
        }
            
        let fakeTxt = ccui.Text.create()
        fakeTxt.ignoreContentAdaptWithSize(true)
        fakeTxt.setFontSize(size)
        fakeTxt.setFontName(fontName)
        let prestr = ""
        do {
            prestr = prestr + " "
            fakeTxt.setString(prestr)
        }while (fakeTxt.getVirtualRendererSize().width < offsetX)
        UIUtils.preStrOfFontNameSizeWidth[key] = [prestr, fakeTxt.getVirtualRendererSize().width]
        console.log("add getPreStr", UIUtils.preStrOfFontNameSizeWidth)
        return [prestr, fakeTxt.getVirtualRendererSize().width]

    }
    
    

    // 先考虑标记
    if (nameLabelId){
        let label = UIItemBuilder.createPropIconWithoutTag(nameLabelId) //现在放道具图集 之后的再议
        let scale = NameTextNode.getFontSize()  / label.height * 1.2
        label.setScale(scale)
        NameTextNode.addChild(label) 

        let [prestr, prewidth] = getPreStr(NameTextNode.getFontName(), NameTextNode.getFontSize(), label.getContentSize().width * scale)        
        const realWidth = UIUtils.fixTextWidth(NameTextNode, prestr + string, width);
        if(NameTextNode.getTextHorizontalAlignment && NameTextNode.getTextHorizontalAlignment() == cc.TEXT_ALIGNMENT_CENTER && NameTextNode.getVirtualRenderer().getDimensions().width){
            // console.log("createNameWithUserShow resize居中调整 extra.labeloffsetx", extra.labeloffsetx, (extra.labeloffsetx || 0) + (width - realWidth)/ 2, string, width, NameTextNode.getVirtualRenderer().width,  "."+ prestr + ".", prewidth)
            extra.labeloffsetx = (extra.labeloffsetx || 0) + (width - realWidth)/ 2
        }
        label.setPosition((extra.labeloffsetx || 0) + prewidth / 2 , (extra.labeloffsety || 0) + NameTextNode.getVirtualRenderer().height / 2)
        // console.log("createNameWithUserShow resize默认字体label位置", label.x, label.y, string, extra.labeloffsety, NameTextNode.getVirtualRenderer().height)

        NameTextNode.prestr = prestr
        NameTextNode.nameLabel = label
    }else{
        UIUtils.fixTextWidth(NameTextNode, string, width); 
        NameTextNode.prestr = "" 
    }

    // 再考虑字体
    function realshowEffect(){


        function createShine( nameEffectId, width){
            let batchNode = cc.Node.create()
            if (nameEffectId == 91005){ //通行证紫星
                let sprite = cc.Sprite.createWithSpriteFrameName("nameeffect/xxz.png");
                sprite.setScale(0)
                sprite.runAction(cc.RepeatForever.create(cc.Sequence.create(
                    cc.scaleTo(5 / 30 , 1), 
                    // cc.MoveTo.create(0, startpos),
                    cc.DelayTime.create(5 / 30),
                    cc.scaleTo(5 / 30 , 0), 
                    cc.DelayTime.create(7 / 30),
                    cc.CallFunc.create(function () {
                        sprite.setPosition(Math.random()* width, Math.random()* NameTextNode.getVirtualRenderer().height)
                    }, sprite)
                    
                )))
                batchNode.addChild(sprite)
                let sprite2 = cc.Sprite.createWithSpriteFrameName("nameeffect/xxz.png");
                sprite2.setScale(0)
                sprite2.runAction(cc.RepeatForever.create(cc.Sequence.create(
                    cc.DelayTime.create(7 / 30),
                    cc.scaleTo(5 / 30 , 1), 
                    // cc.MoveTo.create(0, startpos),
                    cc.DelayTime.create(5 / 30),
                    cc.scaleTo(5 / 30 , 0), 
                    
                    cc.CallFunc.create(function () {
                        sprite2.setPosition(Math.random()* width, Math.random()* NameTextNode.getVirtualRenderer().height)
                    }, sprite2)
                    
                )))
                batchNode.addChild(sprite2)
            }else if (nameEffectId == 91006){ //五彩闪光
                let sprite = cc.Sprite.createWithSpriteFrameName("nameeffect/xxc.png");
                // sprite.setPosition(0, 0)
                sprite.setScale(0.5)
                sprite.runAction(cc.RepeatForever.create(
                    cc.Spawn.create(
                        cc.scaleTo(14 / 30 , 1), 
                        cc.Sequence.create(
                            cc.DelayTime.create(9 / 30),
                            cc.FadeOut.create(5 / 30), 
                            
                            cc.CallFunc.create(function () {
                                sprite.setScale(0.5)
                                sprite.setOpacity(255)
                                sprite.setPosition(Math.random()* width, Math.random()* NameTextNode.getVirtualRenderer().height)
                            }, sprite)
                            
                        )
                    )
                ))
                batchNode.addChild(sprite)

            }

            return batchNode

        }

        if (!NameTextNode) return

        //字体
        let fontName  = SnsProxy.getInstance().getFontNameByTTF("font/FZY3KLite.ttf")
        fontName && NameTextNode.setFontName(fontName) //能获取到再使用
        
        //描边
        let outlinesize = 4
        NameTextNode.enableOutline(cc.color(fontConfig[nameEffectId][0]), outlinesize); 
        setFontColor(NameTextNode, cc.color(255, 255,  255, 255))

        let label = NameTextNode.nameLabel
        let [prestr, prewidth] = (label && getPreStr(NameTextNode.getFontName(), NameTextNode.getFontSize(), label.getContentSize().width * label.scale)) || ["",0]

        if (label){
            //重调位置
            NameTextNode.setString(NameTextNode.getString().replace(NameTextNode.prestr, prestr))
            if(!(NameTextNode.getTextHorizontalAlignment && NameTextNode.getTextHorizontalAlignment() == cc.TEXT_ALIGNMENT_CENTER && NameTextNode.getVirtualRenderer().getDimensions().width)){
                label.x = (extra.labeloffsetx || 0) + prewidth / 2 //非居中才调x位置
                // console.log("createNameWithUserShow resize换字体后非居中调x", label.x, string, nameEffectId, extra.labeloffsetx,  width, NameTextNode.getVirtualRenderer().width, "."+ NameTextNode.prestr + ".", "."+ prestr + ".", prewidth)
            }
            label.y = (extra.labeloffsety || 0) + NameTextNode.getVirtualRenderer().height / 2 //重设字体后尺寸变化导致的偏移
            // console.log("createNameWithUserShow resize换字体后调y", label.y, string, nameEffectId, extra.labeloffsety,  NameTextNode.getVirtualRenderer().height)

        }
        

        if (!NameTextNode.shineNode){
            let shineNode = cc.Node.create()
            NameTextNode.addChild(shineNode);
            NameTextNode.shineNode = shineNode
        }
        NameTextNode.shineNode.x = prewidth

        //字体闪光
        var shine = createShine(nameEffectId, NameTextNode.getVirtualRendererSize().width - prewidth)  //计算出加标记后 换省略号后的实际字体宽度 用于确定闪光范围
        shine && NameTextNode.shineNode.addChild(shine);
        shine && NameTextNode.shineNode.setVisible(true)
        NameTextNode.getVirtualRenderer().setShaderProgram(cc.NameEffectShaders.programForKey(nameEffectId));

    }
    function checkCurrenState(nameLabelId, nameEffectId, string){
        return NameTextNode.currentState.nameLabelId == nameLabelId && NameTextNode.currentState.nameEffectId == nameEffectId && NameTextNode.currentState.string == string
    }
    if (nameEffectId && nameEffectId != 91002){

        //检查资源加载
        let res = fontConfig[nameEffectId][1].slice()
        for (let i = res.length - 1; i >= 0; i--) {
            if (cc.loader.getRes(res[i])) { //实际有的话 去掉
                res.splice(i, 1);
            }
        }

        if (res.length){ //有未加载的资源
            NameTextNode.currentState = {
                nameLabelId,
                nameEffectId,
                string
            }

            ResManager.load(res).then(function(){
                // console.log("createNameWithUserShow loadres", res, UIUtils.loadedEffectRes)
                for (let item of res){
                    UIUtils.loadedEffectRes[item] = (UIUtils.loadedEffectRes[item] || 0) + 1
                }
                if (!checkCurrenState(nameLabelId, nameEffectId, string)){
                    // console.log("createNameWithUserShow not in currentstate", NameTextNode.currentState, nameLabelId, nameEffectId, string)
                    return
                }
                realshowEffect() //加载成功后再显示
            })
            
        }else{
            realshowEffect()
        }
    }

}
UIUtils.releaseLoadedEffectRes = function(){

    ResManager.forceRelease(Object.keys(UIUtils.loadedEffectRes))
    // console.log("createNameWithUserShow releaseres", Object.keys(UIUtils.loadedEffectRes))

    UIUtils.loadedEffectRes = {}
}
UIUtils.getIdFromUsershow = function (userShow, item){
    // userShow = {
    //     head : { },
    //     frame : {},
    //     card : {
    //         id: 90001,
    //         expireTime: -1,
    //         use : 1
    //     },
    //     label : {}
    // }
    let now = Localhost.time()
    if (userShow && userShow[item] && userShow[item].id && userShow[item].use == 1 && (userShow[item].expireTime <= 0 ||  now < userShow[item].expireTime)){
        return userShow[item].id
    } 
    return null

}
UIUtils.getIdAndExpireTimeFromUsershow = function (userShow, item){
    // userShow = {
    //     head : { },
    //     frame : {},
    //     card : {
    //         id: 90001,
    //         expireTime: -1,
    //         use : 1
    //     },
    //     label : {}
    // }
    let now = Localhost.time()
    if (userShow && userShow[item] && userShow[item].id && userShow[item].use == 1 && (userShow[item].expireTime <= 0 ||  now < userShow[item].expireTime)){
        return [userShow[item].id, userShow[item].expireTime]
    } 
    return [0, 0]

}
UIUtils.getNodeWorldScale = function (node) {
    var mat = node.getNodeToWorldTransform()
    var scale = node.getScale()
    return scale
    // FIXME: mat4_transformVector
    // var vec = new cc.vec4(0, 0, 0, 0)
    // var ret = mat4_transformVector(mat, new cc.vec4(scale, 0, 0, 0), vec)
    // return ret.x
}
UIUtils.getPromptNumStr = function (num) {
    if (num >= 100) {
        return "99+"
    } else {
        // WARN: maybe multi result
        return tostring(num)
    }
}
UIUtils.addButtonPrompt = function (button, pos, listener, eventName, tag) {
    var prompt = cc.Sprite.createWithSpriteFrameName("uilibrary/btn_prompt.png")
    var label = cc.Label.createWithSystemFont("", "Arial", 20)
    label.setAnchorPoint(0.5, 0.5)
    var size = prompt.getContentSize()
    label.setPosition(size.width / 2, size.height / 2 + 2)
    prompt.addChild(label)
    prompt.setAnchorPoint(0.5, 0.5)
    prompt.setPosition(pos.x, pos.y)
    button.addChild(prompt, 10)
    prompt.setVisible(false)
    prompt.setScale(0.8)
    button.updatePrompt = function (num) {
        prompt.number = num
        if (num > 0) {
            prompt.setVisible(true)
            label.setString(UIUtils.getPromptNumStr(num))
        } else {
            prompt.setVisible(false)
        }
    }
    button.getPromptNum = function () {
        return prompt.number
    }
    button.showNumTxt = function(b) {
        label.setVisible(b)
    }
    listener.on(eventName, function (event) {
        if (button && button.updatePrompt) {
            button.updatePrompt(event.num)
        }
    }, tag)
}
UIUtils.createMixedBMFont = function (labels, margin) {
    margin = margin || 0
    var node = cc.Node.create()
    var totalWidth = 0
    var currX = 0
    var maxHeight = 0
    var fontCount = 1
    var orders = table()
    for (var _ = 1, v = labels[1]; v; _++, v = labels[_]) {
        var text = ccui.TextBMFont.create(v.text, v.font)
        if (!orders[v.font]) {
            orders[v.font] = fontCount
            fontCount = fontCount + 1
        }
        var zorder = orders[v.font]
        text.setAnchorPoint(0, 0)
        text.setPosition(currX, v.offset || 0)
        if (v.kerning) {
            text.getVirtualRenderer().setAdditionalKerning(tonumber(v.kerning))
        }
        node.addChild(text, zorder)
        text.setColor(v.color || cc.c4b(255, 255, 255, 255))
        var size = text.getContentSize()
        if (size.height > maxHeight) {
            maxHeight = size.height
        }
        currX = currX + size.width + margin + (v.spacing || 0)
    }
    node.setContentSize(cc.size(currX - margin, maxHeight))
    return node
}
//道具专用时间格式
UIUtils.formatPropTime = function(remain){
	var day = Math.floor(remain / 86400)
	var hour   = Math.floor(remain / 3600)
	var minute = Math.floor(remain % 3600 / 60)
	var second = Math.floor(remain % 60)
	if (hour >= 24) {
        return day+"天"+hour%24+"小时"
    } 
	else if (hour >= 1) {
		return string.format("%02d:%02d:%02d", hour, minute, second)
    }else{
		return string.format("%02d:%02d", minute, second)
    }	
}

//更简洁的道具专用时间格式
UIUtils.formatPropTimeSimple = function(remain){
    if (remain > 0){
        //var day = Math.floor(remain / 86400)
        var hourDetail = remain / 3600
        var hour = Math.floor(hourDetail)
        var minuteDetail = remain % 3600 / 60
        var minute = Math.floor(minuteDetail)
        //var second = Math.floor(remain % 60)
        if (hour >= 1) {
            //兼容误差 显示纯配置时间会有误差
            var fixh = hourDetail - hour
            if (fixh > 0.1)
            {
                hour = hour + 1
            }
            return hour+"小时"
        }
        else{
            //兼容误差 显示纯配置时间会有误差
            var fixm = minuteDetail - minute
            if (fixm > 0.1)
            {
                minute = minute + 1
            }
            return minute+"分"
        }	
    }else{
        return "限时"
    }
}

UIUtils.formatTime = function (timeInMSec) {
    // WARN: maybe multi result
    return string.format("%02d:%02d:%02d", Math.floor(timeInMSec / 3600000), Math.floor(timeInMSec / 60000) % 60, Math.floor(timeInMSec / 1000) % 60)
}

UIUtils.formatCountDownTime = function (timeInMSec) {
    // WARN: maybe multi result
    if (timeInMSec <= 0){
        return "00:00"
    }
    let hour = Math.floor(timeInMSec / 3600000)
    let min = Math.floor(timeInMSec / 60000) % 60
    let second = Math.floor(timeInMSec / 1000) % 60

    let day = Math.floor(hour / 24)
    
    if (hour >= 24 ){
        // text.setString( string.format("%02d天%02d时", day, hour % 24))
        return  day + "天" + (hour - 24 * day) + "时"
    }else if (hour == 0){
        return string.format("%02d:%02d", min ,second)
    }else {
        return UIUtils.formatTime(timeInMSec)
    }
}
UIUtils.formatInfinitePrePropTime = function (timeInMSec) {
    // WARN: maybe multi result
    let hour = Math.floor(timeInMSec / 3600000)
    let min = Math.floor(timeInMSec / 60000) % 60
    let second = Math.floor(timeInMSec / 1000) % 60

    let day = Math.floor(hour / 24)
    
    if (hour < 1 ){
        // text.setString( string.format("%02d天%02d时", day, hour % 24))
        return  min + "分" 
    }else {
        return hour + "时"
    }
}
// 这里的字体以下集合中使用font/berlinsansfb_30.fnt 其余使用font/zzgftongxin_40.fnt
var useBerlin = table(
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "/",
    ".",
    ":"
)
UIUtils.mixedSingleLineBitmapText = function () {
    var ret = cc.Node.create()
    ret.setAnchorPoint(cc.p(0, 1))
    var color = cc.c4b(255, 255, 255, 255)
    var children = table()
    function createTextField(buffer) {
        var isBerlin = table.indexof(useBerlin, buffer[1]) !== false
        var textField = cc.LabelBMFont.create(table.concat(buffer), isBerlin && "font/berlinsansfb_30.fnt" || "font/zzgftongxin_40.fnt")
        textField.isBerlin = isBerlin
        textField.setAnchorPoint(cc.p(0, 1))
        textField.setColor(color)
        if (isBerlin) {
            textField.setScale(60 / 39)
            textField.setLocalZOrder(1)
        }
        return textField
    }
    ret.setString = function (self, str) {
        ret.removeAllChildren()
        ret.setContentSize(cc.size(0, 0))
        children = table()
        var buffer = table()
        // var $st46 = string.gfind(tostring(str), "[%z\\1-\\127\\194-\\244][\\128-\\191]*")
        // while(1) {
        let arr = str.split(unicode_split_reg)
        for(let index in arr){
            let xchar = arr[index]
            // var t = $st46[0]($st46[1], $st46[2])
            // var xchar = t[0]
            if (xchar == null) break
            // $st46[2] = xchar
            if ($len(buffer) <= 0) {
                table.insert(buffer, xchar)
            } else if ((table.indexof(useBerlin, buffer[$len(buffer)]) !== false) === (table.indexof(useBerlin, xchar) !== false)) {
                table.insert(buffer, xchar)
            } else {
                var text = createTextField(buffer)
                text.setPositionX(ret.getContentSize().width)
                ret.addChild(text)
                table.insert(children, text)
                var size = text.getContentSize()
                ret.setContentSize(cc.size(text.getPositionX() + size.width * text.getScale(), Math.max(ret.getContentSize().height, size.height * text.getScale())))
                buffer = table([0, xchar])
            }
        }
        var [text, width] = createTextField(buffer)
        text.setPositionX(ret.getContentSize().width)
        ret.addChild(text)
        table.insert(children, text)
        var size = text.getContentSize()
        ret.setContentSize(cc.size(text.getPositionX() + size.width * text.getScale(), Math.max(ret.getContentSize().height, size.height * text.getScale())))
        var size = self.getContentSize()
        for (var i = 1, v = children[1]; v; i++, v = children[i]) {
            if (v.isBerlin) {
                v.setPositionY(v.getContentSize().height * v.getScale() + 8)
            } else {
                v.setPositionY(v.getContentSize().height * v.getScale())
            }
        }
    }
    ret.setColor = function (self, value) {
        for (var i = 1, v = children[1]; v; i++, v = children[i]) {
            v.setColor(value)
        }
        color = value
    }
    return ret
}
